module.exports = __webpack_public_path__ + "static/media/STEEM.b91ac2c3.svg";